import { getParent } from "./getParent";

/**
 * Determines whether the specified element is a descendent of a parent element.
 * @param parent The parent to check whether the specified element is a descendent of.
 * @param element The element to check.
 * @returns True if `element` is a descendent of `parent`, otherwise false.
 */
export function isDescendentOf(parent: Element, element: Element): boolean {
  if (parent === element) return false;

  // if the parent has an overlay redirect, use that instead.

  let current = getParent(element);

  while (current) {
    if (current === parent) return true;
    current = getParent(current);
  }

  return false;
}
